import PropTypes from 'prop-types';
import { OWNERSHIP_BASES } from '../../../utils/ownershipCriteria';

/**
 * Direct / Ultimate / Individuals switch for the ownership figures shown in results and
 * on the company card. Stateless, like PillModeToggle: the caller owns the value. The basis the
 * search used is marked, since only that one decided the match.
 */
const OwnershipBasisToggle = ({ value, searchedBasis = null, onChange, label }) => (
  <fieldset className="ownership-basis-toggle">
    <legend className="ownership-sr-only">{label}</legend>
    {OWNERSHIP_BASES.map((basis) => {
      const isOn = basis.value === value;
      const isSearched = basis.value === searchedBasis;
      return (
        <button
          key={basis.value}
          type="button"
          className={`${isOn ? 'on' : ''}${isSearched ? ' searched' : ''}`}
          aria-pressed={isOn}
          title={isSearched ? `${basis.name} · used in search` : basis.name}
          onClick={() => onChange(basis.value)}
        >
          {basis.short}
          {isSearched && <span className="ownership-sr-only"> (used in search)</span>}
        </button>
      );
    })}
  </fieldset>
);

OwnershipBasisToggle.propTypes = {
  value: PropTypes.string.isRequired,
  searchedBasis: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired
};

export default OwnershipBasisToggle;
